import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../../../components/Modal";
import messages from "../../../../assets/locale/messages";
import { deleteTrainingWorkingSlotRequest } from "../../../../store/TrainingWorkingSlots/actions";
import PropTypes from "prop-types";

function DeleteTrainingSlotModal({
  open,
  selectedItem,
  eventId,
  userId,
  handleClose,
}) {
  const [openStatusModal, setOpenActionModal] = useState(false);

  const lang = useSelector((state) => state.locale.lang);
  const { timeSheet, shared } = messages[lang];

  const dispatch = useDispatch();

  useEffect(() => {
    setOpenActionModal(open);
  }, [open]);

  const handleConfirmModalAction = () => {
    dispatch(
      deleteTrainingWorkingSlotRequest({
        id: selectedItem?.id,
        userId,
        eventId,
      })
    );
    handleClose(false);
    setOpenActionModal(false);
  };

  const handleCloseModal = () => {
    handleClose(false);
    setOpenActionModal(false);
  };

  return (
    <div>
      <Modal
        open={openStatusModal}
        handleClose={handleCloseModal}
        handleCancel={handleCloseModal}
        content={timeSheet.deleteMsg}
        hasActions
        confirmBtnTxt={shared.confirm}
        cancelBtnTxt={shared.cancel}
        handleConfirm={handleConfirmModalAction}
      />
    </div>
  );
}

export default DeleteTrainingSlotModal;

DeleteTrainingSlotModal.propTypes = {
  open: PropTypes.bool,
  eventId: PropTypes.string,
  userId: PropTypes.string,
  selectedItem: PropTypes.object,
  handleClose: PropTypes.func,
};
